import { createContext } from "react";

export type UserLevel = {
	prevLevel: number;
	currentLevel: number;
	nextLevel: number;
	currentExp: number;
	expGained: number;
	levelGained: number;
	expForNextLevel: number;
	expToNextLevel: number;
	progressPercentage: number;
	isLevelUp: boolean;
} | null;

type UserLevelCtx = {
	openLevel: boolean;
	triggerHideLevel: () => void;
	userLevel: UserLevel;
	fetchUserLevel: () => Promise<void>;
};

export const UserLevelContext = createContext<UserLevelCtx>({
	openLevel: false,
	triggerHideLevel: () => {},
	userLevel: null,
	fetchUserLevel: async () => {},
});
